import { orderBy } from "@progress/kendo-data-query";
//import { filterBy } from '@progress/kendo-data-query';
import moment from "moment";
import { saveExcel } from "@progress/kendo-vue-excel-export";
// import helpers from '../../shared/fleetbox-helpers';
import gridbase from "../../components/gridComponentBase.js";
import api from "../../services/api";
import cellTemplate from "../../components/grid/cellTemplate/cellTemplate.vue";
import cellDeleteCommand from "../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import { BNavbarBrand } from "bootstrap-vue";
import { mapGetters } from "vuex";
import geofenceMap from "./map.vue";
import { bus } from "../../main";

export default {
	extends: gridbase,
	components: {
		geofenceMap
	},
	data: function() {
		return {
			dataReady: false,
			columns: [
				{
					field: "localization",
					title: "Localizza",
					configId: "",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myImageCellTemplate",
					editable: false,
					sortable: false,
					filterable: false,
					configByPass: true,
					order: 0
				},
				{
					field: "id",
					title: "Id",
					configId: "id",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					format: "link",
					hidden: true
				},
				{
					field: "name",
					title: "Nome",
					configId: "name",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					format: "link"
				},
				{
					field: "start_date",
					title: "Inizio",
					configId: "start_date",
					format: "date",
					width: "150",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplate",
					filterable: true
				},
				{
					field: "end_date",
					title: "Fine",
					configId: "end_date",
					format: "date",
					width: "150",
					headerCell: "myDateHeaderTemplate",
					cell: "myCellTemplate",
					filterable: true
				},
				{
					field: "check_in",
					title: "Check In",
					configId: "check_in",
					className: "text-center",
					width: "120",
					format: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "check_out",
					title: "Check Out",
					configId: "check_out",
					className: "text-center",
					width: "120",
					format: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "use_api_roads",
					title: "Usa Api Roads",
					configId: "use_api_roads",
					className: "text-center",
					width: "120",
					format: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "poisDesc",
					title: "POI",
					configId: "poisDesc",
					width: "350",
					headerCell: "myPoiHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					sortable: false,
				},
				{
					field: "vehiclesDesc",
					title: "Veicoli",
					configId: "vehiclesDesc",
					width: "350",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false,
					sortable: false,
				},
				{
					field: "daysDesc",
					title: "Giorni",
					configId: "daysDesc",
					width: "350",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false,
					sortable: false,
				},
				{
					field: "",
					title: "",
					configId: "",
					width: "",
					headerCell: "",
					cell: "",
					editable: false,
					sortable: false,
					filterable: true,
					configByPassByField: "daysDesc",
				},
				{
					cell: cellDeleteCommand,
					width: "45px",
					sortable: false,
					editable: false,
					filterable: false,
					headerCell: "",
					configByPassByField: "daysDesc",
					className: "forceActivatedDeleteCommand"
				}
			],

			config: [],
			loading: false,
			items: [],
			canExportGridData: false,

			//table filters
			groupsDataFilters: [],
			groupsDataFiltersSelected: [],
			drivers: [],
			driverNameFilters: [],
			driverNameFilterSelected: [],
			driverSurnameFilters: [],
			driverSurnameFilterSelected: [],
			driverCFFilters: [],
			driverCFFilterSelected: [],

			//POI Modal
			showPoiModal: false,
			geofenceMarker: [],

			configMap: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},

			poiItems: [],
			poiItemsSelected: [],
			poiCategories: [],

			confirmDeleteGeifence: false,
			deleteModalTitle: "",
			deleteGeofenceAction: null,

			filtersByQuery: false,
			isModalShown: false
		};
	},
	created() {
		this.hasSelectedMode = true;
		this.hasEditableMode = true;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		if (this.$route.query && this.$route.query.id) {
			this.filtersByQuery = true;
		}

		this.getConfig();

		this.getPoiCategories();
	},
	methods: {
		onModalShown() {			
			this.isModalShown = true;
		},
		onModalHidden() {
			this.isModalShown = false;
		},
		internalFiltersToUpdate(e) {
			if (e.field == "poisDesc") {
				this.poiItemsSelected = [];
			}
		},
		onGridHeaderFilter() {
			this.getData();
		},
		getGroups: function() {
			var self = this;
			api.getGroupsData().then(res => {
				self.groupsDataFilters = self._.sortBy(
					res
						.filter(function(item) {
							return item.name.length > 0;
						})
						.map(function(item) {
							return {
								id: item.id,
								value: item.name
							};
						}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getAllDrivers() {
			var self = this;
			api.getDriversData({ page: 0, pageSize: 1000000 }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name,
						surname: driver.surname,
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);
				for (var i = 0; i < self.drivers.length; i++) {
					var driver = self.drivers[i];

					// if (driver.name) {
					// 	var alreadyExist =
					// 		self.driverNameFilters.findIndex(item => {
					// 			return item.id == driver.name.toLowerCase();
					// 		}) >= 0;
					// 	if (!alreadyExist) {
					// 		self.driverNameFilters.push({
					// 			id: driver.name.toLowerCase(),
					// 			value: driver.name.toLowerCase()
					// 		});
					// 	}
					// }

					// if (driver.surname) {
					var alreadyExist =
						self.driverSurnameFilters.findIndex(item => {
							return item.id == `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`;
						}) >= 0;
					if (!alreadyExist) {
						self.driverSurnameFilters.push({
							id: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`,
							value: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`
						});
					}
					// }

					if (driver.fiscal_code) {
						var alreadyExist =
							self.driverCFFilters.findIndex(item => {
								return item.id == driver.fiscal_code.toLowerCase();
							}) >= 0;
						if (!alreadyExist) {
							self.driverCFFilters.push({
								id: driver.fiscal_code.toLowerCase(),
								value: driver.fiscal_code.toLowerCase()
							});
						}
					}
				}

				self.driverNameFilters = self._.sortBy(self.driverNameFilters, function(item) {
					return item.value;
				});

				self.driverSurnameFilters = self._.sortBy(self.driverSurnameFilters, function(item) {
					return item.value;
				});

				self.driverCFFilters = self._.sortBy(self.driverCFFilters, function(item) {
					return item.value;
				});
			});
		},
		addGeofence() {
			this.$router.push({
				name: "GEOFENCE_DETAIL",
				params: {
					id: "0"
				}
			});
		},
		getConfig: function() {
			var self = this;
			api.getViewConfig("fleerun_geofences").then(res => {
				self.config = res;
				if (self.config && self.config.length > 0) {
					var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

					orderedConfigColumn.forEach(column => {
						var defColumn = self.columns.find(function(f) {
							return f.configId === column.field;
						});

						if (defColumn && column.enabled) {
							defColumn.title = column.label;

							self.columnsToShow.push(defColumn);
						}
					});

					var columnsByPassByField = self._.filter(self.columns, function(item) {
						return item.configByPassByField && item.configByPassByField.length > 0;
					});

					for (var i = 0; i < columnsByPassByField.length; i++) {
						var clBPf = columnsByPassByField[i];
						var columnRootIndex = self.columnsToShow.findIndex(function(cl) {
							return clBPf.configByPassByField == cl.field;
						});

						if (columnRootIndex < 0) columnRootIndex = self.columnsToShow.length;

						self.columnsToShow.splice(columnRootIndex + 1, 0, clBPf);
					}

					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						var index = columnsByPassConfig[i].order || 0;
						self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
					}

					self.dataReady = true;
				}
			});
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		filterChange: function(ev) {
			this.filter = ev.filter;
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(gr) {
					return gr.value ? gr.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		getData: function() {
			var self = this;
			this.loading = true;

			var data = this._.clone(this.query);

			if (this.columnFilters) {
				for (var i = 0; i < this.columnFilters.length; i++) {
					var clmF = this.columnFilters[i];

					for (var j = 0; j < clmF.filter.filters.length; j++) {
						var filt = clmF.filter.filters[j];
						var field = filt.field;
						var value = filt.value;

						//if (field && field.indexOf("poisDesc") >= 0) field = field.replace("poisDesc", "pois");
						data[field] = value;
					}
				}
			}

			if (this.filtersByQuery) {
				var id = this.$route.query.id;
				data["poisDesc[0]"] = id;

				this.poiItemsSelected.push(id);
			}

			api.getGeofencesList(data).then(res => {
				self.loading = false;

				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						row[c.field] = item[c.field];
					});

					//poi field for map
					row.pois = item.pois;

					return row;
				});

				self.total = res.totalCount;

				self.filtersByQuery = false;
			});
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},

		downloadXlsx(type) {
			var self = this;
			if (type == "csv") this.query["format"] = "csv";
			api.exportXlsx("geofences", this.query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Conducenti.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		goTo(dataItem) {
			var id = dataItem.id;

			this.$router.push({
				name: "GEOFENCE_DETAIL",
				params: {
					id: id
				}
			});
		},
		//#region MAP POI
		openPoiMap(dataItem) {
			this.showPoiModal = true;

			var self = this;
			if (dataItem && dataItem.pois && dataItem.pois.length > 0) {
				var geofenceMarkerToShow = [];

				for (var i = 0; i < dataItem.pois.length; i++) {
					let idItem = dataItem.pois[i];
					let pItem = self.poiItems.find(function(item) {
						return item.id == idItem;
					});

					if (pItem) {
						geofenceMarkerToShow.push(pItem);
					}
				}

				this.geofenceMarker = geofenceMarkerToShow;
			}

			this.showPoiModal = true;
		},

		closePoiModal() {
			this.showPoiModal = false;
			this.geofenceMarker = [];
		},
		removeById(e) {
			if (e && e.dataItem) {
				var itemToDelete = e.dataItem;
				var self = this;

				var geofenceItem = this.items.find(item => {
					return item.id == itemToDelete.id;
				});

				if (geofenceItem) {
					var deleteGeofenceAction = function(e) {
						api.deleteGeofence(e.id)
							.then(res => {
								if (res) {
									self.getData();
								}
							})
							.catch(err => {});

						self.confirmDeleteGeifence = false;
					};

					this.deleteModalTitle = geofenceItem.name;
					this.confirmDeleteGeifence = true;
					this.deleteGeofenceAction = function() {
						deleteGeofenceAction(itemToDelete);
					};
				}
			}
		},
		undoDeleteGeofenceAction() {
			this.confirmDeleteGeifence = false;
			this.deleteModalTitle = "";
			this.deleteGeofenceAction = null;
		},
		////////////////////////////////TO DELETE /////////////////////////////////////////
		getPoiCategories() {
			var self = this;
			api.getPoiCategoriesData().then(res => {
				self.poiCategories = res.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						description: item.description,
						background_color: item.background_color || null,
						icon_image: item.icon_image
					};
				});

				if (self.poiCategories.length > 0) {
					self.poiCategoriesSelected = _.toString(self.poiCategories[0].id);
				}

				self.getPOI();
			});
		},
		getPOI() {
			var self = this;
			this.loading = true;

			api.getPoisData(this.query).then(res => {
				self.loading = false;
				self.poiItems = res.items.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						poi_category_id: item.poi_category_id,
						poi_category_name: self.getPoiDescription(item.poi_category_id),
						poi_category_icon_image: self.getPoiIconImgae(item.poi_category_id),
						poi_category_fill_color: self.getPoiFillColor(item.poi_category_id),
						radius: item.radius,
						location: item.location,
						value: item.name
					};
				});

				self.poiItemToEdit = null;

				self.total = res.totalCount;

				self.getData();
			});
		},
		getPoiDescription(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.name;
			}

			return poiId;
		},
		getPoiFillColor(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.background_color;
			}

			return "#000";
		},
		getPoiIconImgae(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi && poi.icon_image) return poi.icon_image;
				else return "/assets/map/icon/blank.png";
			}

			return null;
		}
		////////////////////////////////TO DELETE /////////////////////////////////////////
		//#endregion
	},

	computed: {
		result: {
			get: function() {
				var self = this;

				var orderedResult = orderBy(self.items, this.sort);
				//var filteredResult = filterBy(orderedResult, this.filter);
				return orderedResult;
			}
		},
		...mapGetters(["settings"])
	}
};
